export class SearchResultField {
  name: string;
  link: string;
  submit: SearchResultField;
  position: number;
  isVisible: boolean;
  guid: number;
  isRecordId: boolean;
  submitId: number;
  metadata: string;
  WIDTH: number;
  INPUTTYPECD: string;
  LOOKUPCD: string;
  LABELKEY: string;
  foptions: any;
  fValue: any;
  attributeCd: string;
  linkViewTypeCd?: string;
  colName: string;
  DATATYPE: string;
}
